var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex relative justify-center items-center mx-auto w-16 h-16"},[_c('icon',{staticClass:"absolute w-full h-full fill-current flesh-shrink-0 animate-spin-slow",attrs:{"name":"gft-circle"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }